import { useMemo, useState } from 'react'

import type { Origin } from 'modules/reports/lib/OriginStruct'
import { ReportEditorStore } from 'modules/reports/lib/Store'
import type Report from 'modules/reports/store/models/Report'

const startStore = (report: Report, origin?: Origin): ReportEditorStore => {
  const reportStore = new ReportEditorStore({
    report,
    origin,
  })
  reportStore.start()

  return reportStore
}

interface SafeProps {
  report: Report
  origin?: Origin
}

export const useStoreSafe = ({ report, origin }: SafeProps): ReportEditorStore => {
  const [initializedStore, setStore] = useState<ReportEditorStore>()

  return useMemo(() => {
    if (initializedStore) return initializedStore

    const store = startStore(report, origin)

    setStore(store)

    return store
  }, [report, initializedStore, setStore])
}

interface Props {
  report: Report | null | undefined
  origin?: Origin
}

const useStore = ({ report, origin }: Props): ReportEditorStore | undefined => {
  const store = useMemo(() => {
    if (!report) return undefined

    return startStore(report, origin)
  }, [report])

  return store
}

export default useStore
